// ...existing code...
export default function Bibliografia() {
  return (
    <div className="container-fluid px-3 px-sm-4 pb-5 quiz-container">
      <style>{`
        @media (min-width: 992px) {
          .quiz-container {
            max-width: 900px;
            margin: 0 auto;
          }
        }
      `}</style>

      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-3">
        <div className="mb-2 mb-sm-0">
          <h5 className="mb-0">Bibliografia y links de utilidad</h5>
          <ul>
            <li><a target="_blank" rel="noopener noreferrer" href="http://www.anmac.gob.ar/pdf/MANUALREGISTRAL-1.pdf">Manual Registral</a></li>
            <li><a target="_blank" rel="noopener noreferrer" href="http://www.anmac.gob.ar/pdf/MET_seg.pdf">Manual Entidades de Tiro</a></li>
            <li><a target="_blank" rel="noopener noreferrer" href="https://www.argentina.gob.ar/normativa/nacional/decreto-395-1975-38821/actualizacion">Decreto Reglamentario 395/75</a></li>
            <li><a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1EXOE4roGICQFQVHFqYtHWf7LLxd2qEKEDJ4XKcpdcms/edit?usp=sharing">Tabla Equivalencias Calibres</a></li>
            <li><a target="_blank" rel="noopener noreferrer" href="https://drive.google.com/file/d/1iOyky6ipd3m7BQnB7Ghd2ePiTzyB6lK8/view?usp=sharing">Flujograma Clasificación de Armas</a></li>
            <li><a target="_blank" rel="noopener noreferrer" href="https://drive.google.com/file/d/1JVqY_cW9mzk25njnfqACKp9gLot_WXOj/view?usp=drive_link">Apunte Clasificación</a></li>
          </ul>
        </div>
        <div className="d-none d-sm-block" />
      </div>
    </div>
  );
}

